<template>
    <div class="container">
        <b-modal
            :model-value="showDialogCreate"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.createCurrency"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog create-currency-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <!-- Campo: Nombre -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.currency }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.nombre"
                            type="text"
                            class="form-input"
                            placeholder="Nombre de la moneda"
                            required
                        />
                    </b-col>
                </b-row>

                <!-- Campo: Acrónimo -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.acronym }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.acronimo"
                            type="text"
                            class="form-input"
                            placeholder="Acrónimo de la moneda"
                            required
                        />
                    </b-col>
                </b-row>

                <!-- Campo: URL -->
                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.url }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="form.url"
                            type="text"
                            class="form-input"
                            placeholder="URL de la moneda"
                            required
                        />
                    </b-col>
                </b-row>

                <!-- Botones de acción -->
                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="mr-2 reset-btn-secondary" @click="closeModal">{{ labels.close }}</b-button>
                    <b-button class="reset-btn-primary" @click="onSubmit" :disabled="isLoading">
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Currency from "@/services/Currency"

export default {
    name: "CreateCurrency",
    props: ['showDialogCreate'],
    data: () => ({
        form: {
            nombre: "",
            acronimo: "",
            url: ""
        },
        isLoading: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    createCurrency: "Crear Moneda",
                    currency: "Nombre",
                    acronym: "Acrónimo",
                    url: "URL",
                    save: "Guardar",
                    close: "Cerrar",
                    infoTitle: "Nueva moneda",
                    infoText: "Completa la información para registrar una nueva moneda."
                }
            } else {
                return {
                    createCurrency: "Create Currency",
                    currency: "Name",
                    acronym: "Acronym",
                    url: "URL",
                    save: "Save",
                    close: "Close",
                    infoTitle: "New currency",
                    infoText: "Complete the information to register a new currency."
                }
            }
        }
    },
    watch: {
        showDialogCreate(val) {
            if (val) {
                this.resetForm()
            }
        }
    },
    methods: {
        resetForm() {
            this.form = {
                nombre: "",
                acronimo: "",
                url: ""
            }
        },
        closeModal() {
            this.$emit('clicked', false)
        },
        onSubmit() {
            this.isLoading = true
            this.form.idUser = this.$store.state.userId
            
            Currency.createCurrency(this.form)
                .then(() => {
                    this.$toast.success(this.$store.state._language == "es-ES" 
                        ? "Moneda creada exitosamente" 
                        : "Currency created successfully")
                    this.$emit('currencyCreated', true)
                    this.closeModal()
                })
                .catch((err) => {
                    console.error(err)
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al crear la moneda" 
                        : "Error creating currency"
                    
                    if (err.response && err.response.data) {
                        if (err.response.status == 412) {
                            errorMessage = this.$store.state._language == "es-ES" 
                                ? "La moneda ya se encuentra registrada" 
                                : "This currency is already registered"
                        } else if (err.response.data.message) {
                            errorMessage = err.response.data.message
                        }
                    }
                    
                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>

<style src="../main.css"></style>